import * as actions from './actions';
import * as getters from './getters';
import moment from 'moment';

import {
    ADD_VACATION,
    ADD_MEDICAL_LEAVE,
    ADD_SICK_LEAVE,
    ADD_TIME_OFF,
    SAVE_MEDICAL_LEAVES,
    SAVE_SICK_LEAVES,
    SAVE_VACATIONS,
    SAVE_TIME_OFF,
    FETCH_VACATIONS,
    FETCH_HOLIDAYS,
    ADD_HOLIDAY,
    DELETE_HOLIDAY,
    SAVE_HOLIDAY,
    EDIT_HOLIDAY,
    CANCEL_EDIT_HOLIDAY,
    REMOVE_MEDICAL_LEAVE,
    REMOVE_VACATION,
    REMOVE_SICK_LEAVE,
    REMOVE_TIME_OFF,
    EDIT_SICK_LEAVE,
    EDIT_VACATION,
    EDIT_TIME_OFF,
    EDIT_MEDICAL_LEAVE,
    DELETE_MEDICAL_LEAVES,
    DELETE_VACATIONS,
    DELETE_SICK_LEAVES,
    DELETE_TIME_OFF,
    CLEAR_ALL_VACATIONS
} from './mutation-types';

const initialState = {
    medicalLeaves: [],
    vacations: [],
    sickLeaves: [],
    timeOff: [],
    addedMedicalLeaves: [],
    addedVacations: [],
    addedSickLeaves: [],
    addedTimeOff: [],
    selectedMedicalLeaves: [],
    selectedVacations: [],
    selectedSickLeaves: [],
    selectedTimeOff: [],
    holidays: []
};

const mutations = {
    [ADD_MEDICAL_LEAVE](state, medicalLeave) {
        state.addedMedicalLeaves = [...state.addedMedicalLeaves, medicalLeave];
    },
    [ADD_VACATION](state, vacation) {
        state.addedVacations = [...state.addedVacations, vacation];
    },
    [ADD_SICK_LEAVE](state, sickLeave) {
        state.addedSickLeaves = [...state.addedSickLeaves, sickLeave];
    },
    [ADD_TIME_OFF](state, timeOff) {
        state.addedTimeOff = [...state.addedTimeOff, timeOff];
    },
    [SAVE_MEDICAL_LEAVES](state, savedMedicalLeaves) {
        const newMedicalLeaves = state.addedMedicalLeaves.map(
            ({ observationId, ...medicalLeave }, index) => ({
                ...medicalLeave,
                id: savedMedicalLeaves[index]
            })
        );

        state.addedMedicalLeaves = [];
        state.medicalLeaves = [...state.medicalLeaves, ...newMedicalLeaves];
    },
    [SAVE_VACATIONS](state, savedVacationIds) {
        const newVacations = state.addedVacations.map(
            ({ observationId, ...medicalLeave }, index) => ({
                ...medicalLeave,
                id: savedVacationIds[index]
            })
        );

        state.vacations = [...state.vacations, ...newVacations];
        state.addedVacations = [];
    },
    [SAVE_SICK_LEAVES](state, savedSickLeaveIds) {
        const newSickLeaves = state.addedSickLeaves.map(
            ({ observationId, ...medicalLeave }, index) => ({
                ...medicalLeave,
                id: savedSickLeaveIds[index]
            })
        );

        state.sickLeaves = [...state.sickLeaves, ...newSickLeaves];
        state.addedSickLeaves = [];
    },
    [SAVE_TIME_OFF](state, savedTimeOff) {
        const newTimeOffs = state.addedTimeOff.map(
            ({ observationId, ...medicalLeave }, index) => ({
                ...medicalLeave,
                id: savedTimeOff[index]
            })
        );

        state.timeOff = [...state.timeOff, ...newTimeOffs];
        state.addedTimeOff = [];
    },
    [FETCH_VACATIONS](state, vacations) {
        for (let vacationType in vacations) {
            vacations[vacationType].forEach(vacation => {
                vacation.startDate = moment(vacation.startDate).format(
                    'YYYY-MM-DD'
                );
                vacation.endDate = moment(vacation.endDate).format(
                    'YYYY-MM-DD'
                );
            });
            if (vacationType === 'vacations') {
                vacations[vacationType].forEach(vacation => {
                    vacation.startEmploymentPeriodDate = moment(
                        vacation.startEmploymentPeriodDate
                    ).format('YYYY-MM-DD');
                    vacation.endEmploymentPeriodDate = moment(
                        vacation.endEmploymentPeriodDate
                    ).format('YYYY-MM-DD');
                    vacation.orderDate = moment(
                        vacation.orderDate
                    ).format('YYYY-MM-DD');
                });
            }
        }

        state.medicalLeaves = [...vacations.medicalLeaves];
        state.vacations = [...vacations.vacations];
        state.sickLeaves = [...vacations.sickLeaves];
        state.timeOff = [...vacations.timeOff];
    },
    [FETCH_HOLIDAYS](state, holidays) {
        state.holidays = [
            ...holidays.map(holiday => {
                return {
                    name: moment(holiday.date).format('YYYY-MM-DD'),
                    id: holiday.id,
                    editting: false,
                    checked: false,
                    editable: true
                };
            })
        ];
    },

    [ADD_HOLIDAY](state, newHoliday) {
        state.holidays = [
            ...state.holidays
                .filter(holiday => holiday.id !== -1)
                .map(holiday => ({
                    ...holiday,
                    editting: false
                })),
            newHoliday
        ];
    },

    [DELETE_HOLIDAY](state, holidayId) {
        state.holidays = state.holidays.filter(item => item.id !== holidayId);
    },

    [SAVE_HOLIDAY](state, holiday) {
        const holidayId = state.holidays.findIndex(holiday => holiday.editting);

        if (holidayId !== -1) {
            state.holidays[holidayId].id = holiday.id;
            state.holidays[holidayId].editting = false;
        }
    },

    [EDIT_HOLIDAY](state, holidayId) {
        state.holidays = state.holidays
            .filter(holiday => holiday.id !== -1)
            .map(holiday => ({
                ...holiday,
                editting: holiday.id === holidayId
            }));
    },

    [CANCEL_EDIT_HOLIDAY](state) {
        const holidayIndex = state.holidays.findIndex(holiday => holiday.editting);

        if (holidayIndex !== -1) {
            if (state.holidays[holidayIndex].id > 0) {
                state.holidays[holidayIndex].editting = false;
            } else {
                state.holidays.splice(holidayIndex, 1);
            }
        }
    },
    [REMOVE_MEDICAL_LEAVE](state, medicalLeave) {
        if (!isNaN(medicalLeave.observationId)) {
            state.addedMedicalLeaves = state.addedMedicalLeaves.filter(
                item => item.observationId !== medicalLeave.observationId
            );
        } else {
            state.medicalLeaves = state.medicalLeaves.filter(
                exstengMedicalLeave =>
                    exstengMedicalLeave.id !== medicalLeave.id
            );
            state.selectedMedicalLeaves = [
                ...state.selectedMedicalLeaves,
                medicalLeave.id
            ];
        }
    },
    [REMOVE_VACATION](state, vacation) {
        if (!isNaN(vacation.observationId)) {
            state.addedVacations = state.addedVacations.filter(
                item => item.observationId !== vacation.observationId
            );
        } else {
            state.vacations = state.vacations.filter(
                existingVacation => existingVacation.id !== vacation.id
            );
            state.selectedVacations = [...state.selectedVacations, vacation.id];
        }
    },
    [REMOVE_SICK_LEAVE](state, sickLeave) {
        if (!isNaN(sickLeave.observationId)) {
            state.addedSickLeaves = state.addedSickLeaves.filter(
                item => item.observationId !== sickLeave.observationId
            );
        } else {
            state.sickLeaves = state.sickLeaves.filter(
                existingSickLeave => existingSickLeave.id !== sickLeave.id
            );
            state.selectedSickLeaves = [
                ...state.selectedSickLeaves,
                sickLeave.id
            ];
        }
    },
    [REMOVE_TIME_OFF](state, timeOff) {
        if (!isNaN(timeOff.observationId)) {
            state.addedTimeOff = state.addedTimeOff.filter(
                item => item.observationId !== timeOff.observationId
            );
        } else {
            state.timeOff = state.timeOff.filter(
                existingtimeOff => existingtimeOff.id !== timeOff.id
            );
            state.selectedTimeOff = [...state.selectedTimeOff, timeOff.id];
        }
    },
    [EDIT_SICK_LEAVE](state, updatedSickLeave) {
        if (updatedSickLeave.id) {
            const sickLeaveIndex = state.sickLeaves.findIndex(sickLeave => sickLeave.id === updatedSickLeave.id);
            state.sickLeaves[sickLeaveIndex] = updatedSickLeave;
        } else {
            const sickLeaveIndex = state.addedSickLeaves.findIndex(sickLeave => sickLeave.observationId === updatedSickLeave.observationId);
            state.addedSickLeaves[sickLeaveIndex] = updatedSickLeave;
        }
    },
    [EDIT_VACATION](state, updatedVacation) {
        if (updatedVacation.id) {
            const vacationIndex = state.vacations.findIndex(vacation => vacation.id === updatedVacation.id);
            state.vacations[vacationIndex] = updatedVacation;
        } else {
            const vacationIndex = state.addedVacations.findIndex(vacation => vacation.observationId = updatedVacation.observationId);
            state.addedVacations[vacationIndex] = updatedVacation;
        }
    },
    [EDIT_TIME_OFF](state, updatedTimeOff) {
        if (updatedTimeOff.id) {
            const timeOffIndex = state.timeOff.findIndex(timeOff => timeOff.id === updatedTimeOff.id);
            state.timeOff[timeOffIndex] = updatedTimeOff;
        } else {
            const timeOffIndex = state.addedTimeOff.findIndex(timeOff => timeOff.observationId === updatedTimeOff.observationId);
            state.addedTimeOff[timeOffIndex] = updatedTimeOff;
        }
    },
    [EDIT_MEDICAL_LEAVE](state, updatedMedicalLeave) {
        if (updatedMedicalLeave.id) {
            const medicalLeaveIndex = state.medicalLeaves.findIndex(medicalLeave => medicalLeave.id === updatedMedicalLeave.id);
            state.medicalLeaves[medicalLeaveIndex] = updatedMedicalLeave;
        } else {
            const medicalLeaveIndex = state.addedMedicalLeaves.findIndex(medicalLeave => medicalLeave.observationId === updatedMedicalLeave.observationId);
            state.addedMedicalLeaves[medicalLeaveIndex] = updatedMedicalLeave;
        }
    },
    [DELETE_MEDICAL_LEAVES](state) {
        state.selectedMedicalLeaves = [];
    },
    [DELETE_VACATIONS](state) {
        state.selectedVacations = [];
    },
    [DELETE_SICK_LEAVES](state) {
        state.selectedSickLeaves = [];
    },
    [DELETE_TIME_OFF](state) {
        state.selectedTimeOff = [];
    },
    [CLEAR_ALL_VACATIONS](state) {
        Object.assign(state, initialState);
    }
};

export default {
    state: {
        ...initialState
    },
    actions,
    getters,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/vacation/index.js